import React, { useEffect, useState } from 'react';
import { bulletinBoardDetails } from '../../../data/bulletin-data';
import { Link } from 'react-router-dom';

const BulletinBoard = () => {
  // Duplicate the bulletinBoardDetails array to ensure seamless scrolling
  const duplicatedDetails = [...bulletinBoardDetails, ...bulletinBoardDetails];

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const scrollContainer = document.querySelector('.scroll-container');

    if (scrollContainer) {
      scrollContainer.style.animationPlayState = isHovered
        ? 'paused'
        : 'running';
    }
  }, [isHovered]);

  return (
    <div className="h-[70vh] space-y-4 overflow-hidden rounded-lg bg-gradient-to-r from-blue-100 p-6 shadow-md">
      {/* <h2 className="text-2xl font-bold text-gray-800 mb-4">Bulletin Board</h2> */}
      <div className="scroll-container">
        {duplicatedDetails.map((bulletin, id) => (
          <div
            key={id}
            className="mb-4 rounded-lg border bg-white p-4 shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-lg"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Link
              to={bulletin?.link}
              className="block text-blue-600 transition-colors duration-300 hover:text-blue-600"
            >
              <p className="mb-2 text-lg font-semibold">{bulletin?.text}</p>
            </Link>
            <p className="text-sm font-bold italic text-slate-800">
              {bulletin?.status}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BulletinBoard;
